import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API}`,
});

// REQUEST INTERCEPTOR
api.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get("access_token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Only attempt refresh if we get a 401 and haven't retried yet
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        // Get the refresh token from cookies
        const refreshToken = Cookies.get("refresh_token");
        if (!refreshToken) {
          throw new Error("No refresh token found; need to log in again.");
        }

        // Make a request to /auth with the refresh token in the Bearer header
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}${process.env.REACT_APP_REFRESH_TOKEN}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        // Suppose your backend returns a new access token in data.access_token
        const newAccessToken = data.access_token;

        // Save the new tokens in cookies
        Cookies.set("access_token", newAccessToken);

        // Update the authorization header for the original request
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        // Retry the original request with the new token
        return api(originalRequest);
      } catch (refreshError) {
        // If anything goes wrong with refresh, remove tokens & redirect to sign-in
        Cookies.remove("access_token");
        Cookies.remove("refresh_token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_email");
        localStorage.removeItem("user_id");
        window.location.href = "/signin";
        return Promise.reject(refreshError);
      }
    }

    // If status is 403 or other error, handle appropriately
    if (error.response && error.response.status === 403) {
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      localStorage.removeItem("user_name");
      localStorage.removeItem("user_email");
      localStorage.removeItem("user_id");
      window.location.href = "/signin";
    }

    return Promise.reject(error);
  }
);

export default api;
